class OrientationMode
{
	/**
	 *
	 */
	public static DEFAULT:string = "default";

	/**
	 *
	 */
	public static CAMERA_PLANE:string = "cameraPlane";

	/**
	 *
	 */
	public static CAMERA_POSITION:string = "cameraPosition";
}

export default OrientationMode;